export default {
  OFFERS: {
    TITLE: 'Panel de ofertas',
    PROPOSED_BANNER: {
      TITLE: 'Ofertas pendientes de crearse',
      SUBTITLE: 'Tienes carpetas de selección pendientes. Complétalas para crear las ofertas e invitar a tus candidat@s.',
      VIEW_BTN: 'Ver →',
      TABLE: {
        DATE: 'Fecha',
        DATE_TOOLTIP: 'Fecha en la que se creó la oferta',
        TITLE_COL: 'Título / Puesto',
        CANDIDATES: 'Candidat@s por invitar',
        CANDIDATES_LABEL: 'candidat@s',
        CANDIDATES_TOOLTIP: 'Una vez que crees la oferta, l@s candidat@s recibirán una invitación para inscribirse a la vacante',
        STATUS: 'Estado',
        ACTIONS: 'Acciones',
        BADGE: 'Oferta pendiente de crearse',
        BADGE_TOOLTIP: 'Crea la oferta: se invitará automáticamente a l@s candidat@s que hayas seleccionado y, una vez que se inscriban, podrás gestionarl@s.',
        CREATE_BTN: 'Crear oferta',
        DISCARD_BTN: 'Eliminar',
        SHOW_MORE: 'Ver más',
        SHOW_LESS: 'Ver menos',
      },
      CONFIRM_DISCARD: {
        HEADER: 'Eliminar oferta en creación',
        MESSAGE: '¿Estás segur@ que deseas eliminar esta oferta en creación?',
        ACCEPT: 'Eliminar',
        REJECT: 'Cancelar',
      },
      DELETE_SUCCESS: 'Oferta en creación eliminada correctamente.',
      INVITE_SUCCESS: 'Candidat@s invitad@s correctamente. Oferta propuesta completada.',
      PARTIAL_INVITE: 'Oferta creada, pero hubo un problema al invitar a algunos candidat@s. Puedes invitarles manualmente desde el detalle de la oferta.',
    },
    ACTIVE_OFFERS: 'Ofertas con actividad',
    NEW_OFFER: 'Crear nueva oferta',
    SHOW_PUBLISHED: 'Publicado:',
    DESCRIPTION: 'Descripción',
    TABLE: {
      TITLE: 'Ofertas',
      HEADER: {
        DATE: 'Fecha',
        DATE_TOOLTIP: 'Fecha en la que se creó la oferta',
        TITLE: 'Título / Puesto',
        LOCATION: 'Sucursal',
        TYPE: 'Modalidad',
        CONTRACT_TYPE: 'Tipo de empleo',
        WORKING_DAY: 'Tipo de jornada',
        ACTIONS: 'Acciones Oferta',
        DUPLICATE_ACTIONS: 'Acción',
        SALARY_RANGE: 'Rango salarial',
        CANDIDATES: 'Inscrit@s',
        CANDIDATES_TOOLTIP: 'Candidat@s inscrit@s. Han grabado su video de presentación y están en el proceso de selección',
        SELECTED: 'Finalistas',
        STATUS: 'Estado',
      },
      FILTERS: {
        CITY: 'Todas las ciudades',
        LOCATION: 'Todas las sucursales',
        STATUS: 'Todos los estados',
        TYPE: 'Todas las ofertas',
        SEARCH_OFFER: 'Buscar oferta',
        SEARCH: 'Buscar',
        SEARCH_CANDIDATES: 'Buscar candidat@',
        NO_LOCATIONS: 'Selecciona primero una ciudad',
        NO_CITIES: 'No hay ciudades disponibles',
        NO_OFFERS: 'No hay ofertas disponibles',
      },
      NO_DATA: 'Aún no tienes ofertas.',
      NO_DATA_DESCRIPTION: 'Crea la primera desde el botón "Crear nueva oferta" en la parte superior.',
      FIRST_OFFER_MODAL: {
        HEADER: '¡Bienvenid@ a wokap!',
        MESSAGE: 'Este es tu panel de ofertas. Aún no tienes ninguna. ¿Quieres crear la primera ahora?',
        ACCEPT: 'Crear primera oferta',
        REJECT: 'Ahora no',
      },
      CONFIRM_PAUSE: {
        HEADER: 'Pausar la oferta',
        MESSAGE: 'Mientras esté pausada, la oferta no se mostrará activa para nuev@s candidat@s, pero l@s candidat@s ya inscrit@s seguirán en el proceso. ¿Estás segur@ que deseas pausar la oferta?',
        ACCEPT: 'Pausar',
        REJECT: 'Cancelar',
      },
      CONFIRM_OPEN: {
        HEADER: 'Reactivar la oferta',
        MESSAGE: 'Al reactivarla, la oferta se volverá a mostrar activa para nuev@s candidat@s. ¿Estás segur@ que deseas reactivar la oferta? ',
        ACCEPT: 'Reactivar',
        REJECT: 'Cancelar',
      },
      CONFIRM_DISCARD: {
        HEADER: 'Finalizar oferta',
        MESSAGE: 'Al finalizarla, dejará de estar activa para nuev@s candidat@s. L@s candidat@s inscrit@s, serán notificad@s con este mensaje:<br/><br/>Gracias por tu interés en {{companyName}}. El proceso de selección ha finalizado y tu candidatura no fue seleccionada. Te invitamos a seguir pendiente de nuevas oportunidades.<br/><br/>Si quieres enviar un mensaje personalizado, ve a la sección Inscrit@s, selecciona a l@s candidat@s que desees y envíales tu mensaje.<br/><br/>¿Estás segur@ que deseas finalizar la oferta?',
        ACCEPT: 'Finalizar',
        REJECT: 'Cancelar',
      },
      CONFIRM_DELETE: {
        HEADER: 'Eliminar oferta',
        MESSAGE: '¿Estás segur@ que deseas eliminar esta oferta? Esta acción es irreversible y la oferta se eliminará de tu panel de ofertas.',
        ACCEPT: 'Eliminar',
        REJECT: 'Cancelar',
      },
      BEFORE_DELETE: {
        HEADER: 'Antes de eliminar',
        MESSAGE: 'Para mantener una buena imagen y comunicación con l@s candidat@s, primero finaliza tu oferta para que queden informad@s. Una vez finalizada, podrás eliminarla.',
        ACCEPT: 'Finalizar oferta',
        REJECT: 'Cancelar',
      },
      DELETE_SUCCESS: 'Oferta eliminada correctamente.',
      PIN_SUCCESS: 'La oferta se fijó correctamente y ahora aparece arriba en tu panel de ofertas. Arrástrala para cambiar su posición y ordenar tus ofertas como prefieras.',
      UNPIN_SUCCESS: 'Oferta desfijada correctamente.',
      ACTIONS: {
        PIN: 'Fijar oferta',
        UNPIN: 'Desfijar oferta',
        SEE: 'Ver/Editar oferta',
        DUPLICATE: 'Duplicar oferta',
        START: 'Reactivar oferta',
        PAUSE: 'Pausar oferta',
        END: 'Finalizar oferta',
        SHARE: 'Copiar/Compartir oferta',
        REMOVE: 'Eliminar oferta',
        DISABLED_PAUSED: 'Esta oferta está pausada',
        DISABLED_CLOSED: 'Esta oferta está cerrada',
        SEE_DISABLED_CLOSED: 'Esta oferta está cerrada. Puedes verla, pero no editarla',
        SHARE_DISABLED_PAUSED: 'Esta oferta está pausada, no puedes compartirla',
        SHARE_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes compartirla',
        EDIT_INTERVIEW_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes crear ni editar entrevistas',
        PAUSE_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes pausarla',
        RESUME_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes reactivarla',
        END_DISABLED_CLOSED: 'Esta oferta está cerrada, no puedes finalizarla nuevamente',
        // Legacy keys (mantener por compatibilidad)
        START_DISABLED_CLOSED: 'Esta oferta ya está cerrada y no puede pausarse.',
        CREATE_INTERVIEW_DISABLED_CLOSED: 'Esta oferta está cerrada. No puedes crear ni editar entrevistas.',
      },
      DUPLICATING: {
        TITLE: 'Duplicando',
        MESSAGE: 'La oferta está siendo duplicada. Te notificaremos y redirigiremos cuando esté lista.',
      },
    },
    CANDIDATES: {
      NEW: 'Por revisar',
      UNREAD_CHATS: 'Chats',
      PROCESS: 'Entrevistas',
      TOOLTIP: {
        NEW: 'Candidat@s pendientes por revisar',
        UNREAD_CHATS: 'Chats pendientes de responder',
        PROCESS: 'Entrevistas respondidas',
      },
    },
    TYPE: {
      REMOTE: 'Remoto',
      IN_PERSON: 'Presencial',
      HYBRID: 'Híbrido',
    },
    CONTRACT_TYPE: {
      PERMANENT: 'Indefinido',
      TEMPORARY: 'Temporal',
      PROJECT_BASED: 'Por proyecto',
      FREELANCE: 'Freelance',
      INTERNSHIP: 'Prácticas',
    },
    WORKING_DAY: {
      FULL_TIME: 'Tiempo completo',
      PART_TIME: 'Medio tiempo',
      PER_HOUR: 'Por horas',
    },
    SALARY: {
      PAYMENT_TYPE: {
        MONTHLY: 'Mensuales',
        BIWEEKLY: 'Quincenales',
        WEEKLY: 'Semanales',
        ANNUAL: 'Anuales',
        HOURLY: 'Por hora',
        PROJECT: 'Por proyecto',
      },
      CURRENCY: {
        EUR: 'EUR',
        USD: 'USD',
        MXN: 'MXN',
        COP: 'COP',
        ARS: 'ARS',
        PEN: 'PEN',
        CLP: 'CLP',
        GTQ: 'GTQ',
        CRC: 'CRC',
        BRL: 'BRL',
        CAD: 'CAD',
        DOP: 'DOP',
        VES: 'VES',
      },
      NET_GROSS_TYPE: {
        GROSS: 'Bruto',
        NET: 'Neto',
      },
      LABEL: {
        PAYMENT_TYPE: 'Frecuencia de pago',
        CURRENCY: 'Moneda',
        NET_GROSS_TYPE: 'Tipo de salario',
        AMOUNT_FROM: 'Salario mínimo',
        AMOUNT_TO: 'Salario máximo (Opcional)',
      },
      PLACEHOLDER: {
        PAYMENT_TYPE: 'Selecciona una opción',
        CURRENCY: 'Selecciona uno...',
        NET_GROSS_TYPE: 'Selecciona uno...',
        AMOUNT_FROM: 'Ej. 2000',
        AMOUNT_TO: 'Ej. 3500',
      },
      VALIDATION: {
        ALL_OR_NONE: 'La información salarial es opcional. Si decides incluirla en tu oferta, los siguientes cuatro campos son obligatorios: salario mínimo, frecuencia de pago, moneda y tipo de salario.',
        AMOUNT_TO_GREATER: 'El salario máximo debe ser mayor que el mínimo',
        ONLY_NUMBERS: 'Solo se permiten números enteros',
      },
      CLEAR: 'Borrar toda la información salarial',
    },
    STATUS: {
      OPEN: 'Abierta',
      PAUSED: 'Pausada',
      CLOSED: 'Finalizada',
    },
    CANDIDATE_STATUS: {
      OFFER_WITHOUT_INTERVIEW: 'N/A',
      OFFER_WITHOUT_INTERVIEW_TOOLTIP: 'Esta oferta no tiene entrevista, entra a “Crear entrevista” para crearla.',
      ENROLLED: 'Inscrit@',
      PROCESS: 'Preseleccionad@',
      SELECTED: 'Finalista',
      DISCARDED: 'Descartad@',
      SUGGESTED: 'Sugerid@',
      PROCESS_INTERVIEW_ANSWERED: 'Respondida',
      PROCESS_INTERVIEW_PENDING: 'Enviada',
      PROCESS_NEW_ANSWER: 'Nueva respuesta',
      PROCESS_NEW_QUESTION: 'Nueva pregunta',
      PROCESS_SPECIFIC_QUESTION_PENDING: 'Pregunta directa pendiente',
      PROCESS_SPECIFIC_QUESTION_ANSWERED: 'Pregunta directa respondida',
      PROCESS_INTERVIEW_PENDING_SEND: 'No enviada',
      RATED: 'Valorad@',
      RATING_UPDATED: 'Valoración actualizada',
      NEW_COMMENT: 'Nota añadida',
      UPDATED_COMMENT: 'Nota actualizada',
      DELETED_COMMENT: 'Nota eliminada',
      PROCESS_INTERVIEW_NOT_APPLICABLE: 'N/A',
      STATUS_SUGGESTED: 'Sugerid@',
      STATUS_ENROLLED: 'Inscrit@',
      STATUS_PROCESS: 'Preseleccionad@',
      STATUS_SELECTED: 'Finalista',
      STATUS_DISCARDED: 'Descartad@',
      INTERVIEW_RESENT: 'Entrevista reenviada',
      INTERVIEW_SENT: 'Entrevista enviada',
      INTERVIEW_ANSWERED: 'Entrevista respondida',
      INTERVIEW_QUESTIONS_REGENERATED: 'Preguntas de entrevista regeneradas',
      SPECIFIC_QUESTIONS_SENT: 'Preguntas directas enviadas',
      SPECIFIC_QUESTIONS_ANSWERED: 'Preguntas directas respondidas',
    },
    ERRORS: {
      OFFER_NOT_FOUND: 'La oferta seleccionada no existe o no es posible editarla.',
      TITLE_NOT_BLANK: 'El título de la oferta no puede estar vacío.',
      ENTITY_LOCATION_NOT_FOUND: 'La ubicación seleccionada no existe.',
      OFFER_TYPE_NOT_BLANK: 'La modalidad de la oferta no puede estar vacía.',
      OFFER_STATUS_NOT_BLANK: 'El estado de la oferta no puede estar vacío.',
      OFFER_ALREADY_HAS_THIS_STATUS: 'La oferta ya tiene este estado.',
      QUESTION_MIN_LENGTH: 'La pregunta debe tener al menos 3 caracteres.',
      QUESTION_NOT_BLANK: 'La pregunta no puede estar vacía.',
      AI_ERROR: 'La IA no es capaz de resolver tu petición por favor cambia tu mensaje.',
      FILE_NOT_BLANK: 'El archivo no puede estar vacío.',
      SALARY_RANGE_TOO_LONG: 'El rango salarial no puede tener más de 15 caracteres.',
      VIDEO_OFFER_NOT_FOUND: 'No se subido el video de la oferta correctamente por favor inténtelo de nuevo.',
      FILE_MIME_TYPE_WRONG: 'El archivo debe ser un video.',
      FILE_MAX_SIZE: 'El archivo no puede pesar más de 50MB.',
      SUMMARY_NOT_BLANK: 'La descripción no puede estar vacía.',
      VIDEO_NOT_VERTICAL: 'El video debe ser en formato vertical.',
      INVALID_VIDEO_FILE: 'El formato del video no está soportado, recomendamos usar mp4.',
      QUESTION_MAX_LENGTH: 'La pregunta no puede tener más de 255 caracteres.',
      PROMPT_REQUIRED: 'El campo de sugerencia es obligatorio.',
      FAILED_TO_LOAD_LOCATIONS: 'Error al cargar las ubicaciones. Por favor, inténtalo de nuevo.',
      OFFER_CREATION_ERROR: 'Error al crear la oferta. Por favor, inténtalo de nuevo.',
      UNKNOWN_ERROR: 'Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo.',
    },
    DETAIL: {
      TITLE: 'Oferta',
      BACK: 'Volver a Ofertas',
      ACTIONS: {
        DUPLICATE: 'Duplicar',
        DELETE: 'Eliminar',
        PAUSE: 'Pausar',
        RESUME: 'Reactivar',
        END: 'Finalizar',
        SEE: 'Ver/Editar',
        SHARE: 'Compartir',
        PREVIEW: 'Previsualizar',
        CREATE_INTERVIEW: 'Crear entrevista',
        EDIT_INTERVIEW: 'Editar entrevista',
        CREATE_INTERVIEW_TOOLTIP: 'Crear entrevista',
        EDIT_INTERVIEW_TOOLTIP: 'Editar entrevista',
      },
      KPI: {
        TOTAL: 'Inscrit@s',
        WITHOUT_CLASSIFICATION: 'Sin valorar',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '4_5_STARS': '4 y 5 estrellas',
        INTERVIEWEES: 'Entrevistad@s',
        SELECTED: 'Finalistas',
      },
      FILTER: {
        BUTTON: 'Filtrar candidat@s',
        // Tooltip for the small X button and dynamic button label when showing count
        RESET_TOOLTIP: 'Borrar filtros',
        BUTTON_COUNT_SINGULAR: '1 Filtro aplicado',
        BUTTON_COUNT_PLURAL: '{{count}} Filtros aplicados',
        DEFAULT: {
          PLACEHOLDER: 'Filtrar por',
          DEFAULT: 'Por defecto',
          ALL_REQUIREMENTS: 'Todos los requisitos',
          MINIMUM_REQUIREMENTS: 'Requisitos mínimos',
          DESIRED_REQUIREMENTS: 'Requisitos deseados',
          CUSTOM: 'Personalizados',
        },
        INTERVIEW: {
          PLACEHOLDER: 'Entrevista',
          ALL: 'Todas',
          INTERVIEW_ANSWERED: 'Respondida',
          INTERVIEW_SENT: 'Enviada',
          INTERVIEW_PENDING: 'No enviada',
          INTERVIEW_NA: 'N/A',
        },
        CLASSIFICATION: {
          PLACEHOLDER: 'Valoración',
          ALL: 'Todas',
          NO_CLASSIFICATION: 'Sin valorar',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '0_STARS': '0 estrellas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '1_STARS': '1 estrella',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '2_STARS': '2 estrellas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '3_STARS': '3 estrellas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '4_STARS': '4 estrellas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '5_STARS': '5 estrellas',
        },
        STATUS: { PLACEHOLDER: 'Estado' },
      },
      FILTER_SIDEBAR: {
        CLEAR_FILTERS_BTN: 'Limpiar filtros',
        CLEAR_FILTERS_TOOLTIP: 'Quitar todos los filtros seleccionados y volver a ver a tod@s l@s candidat@s.',
        APPLY_FILTERS_BTN: 'Aplicar filtros',
        APPLY_FILTERS_TOOLTIP: 'Ver a tod@s l@s candidat@s que cumplen con los filtros seleccionados.',
        RESET: 'Restablecer filtros',
        CLEAR_BTN: 'Borrar filtros',
        CLEAR_TOOLTIP: 'Borrar filtros',
        // Tooltip for the small X button in table toolbars
        RESET_TOOLTIP: 'Borrar filtros',
        // Button label when there are N active filters
        BUTTON_COUNT_SINGULAR: '1 Filtro aplicado',
        BUTTON_COUNT_PLURAL: '{{count}} Filtros aplicados',
        APPLY_BTN: 'Aplicar',
        APPLY_TOOLTIP: 'Aplicar filtros',
        TITLE: 'Filtrar candidat@s',
        STAGE_QUESTION: '¿Qué etapa deseas filtrar?',
        SEARCH_PLACEHOLDER: 'Buscar...',
        TABS: {
          ALL: 'Inscrit@s',
          SUGGESTED: 'Sugerid@s',
          ENROLLED: 'Por revisar',
          IN_PROCESS: 'Preseleccionad@s',
          SELECTED: 'Finalistas',
          DISCARDED: 'Descartad@s',
        },
        SUBTITLE: '¿Qué etapa deseas filtrar?',
        ENROLLED_TITLE: 'Filtros candidat@s Por revisar',
        CONTACTED_FILTER_LABEL: 'Contactad@',
        INVITED_FILTER_LABEL: 'Invitad@',
        IN_PROCESS_TITLE: 'Filtros candidat@s Preseleccionad@s',
        SELECTED_TITLE: 'Filtros candidat@s Finalistas',
        SUGGESTED_TITLE: 'Filtros candidat@s Sugerid@s',
        DISCARDED_TITLE: 'Filtros candidat@s Descartad@s',
        ALL_TITLE: 'Filtros candidat@s Inscrit@s',
        SCOPE: {
          LABEL: 'Filtrar sobre',
          ALL: 'Tod@s los inscrit@s de la oferta',
          ONLY: 'Solo',
        },
        COLUMN: {
          PROFILE: 'Perfil',
          PROCESS: 'Proceso',
        },
        FORMATION: {
          TITLE: 'Formación / Estudios',
          SOURCE: 'Perfiles de candidat@s inscritos',
          EMPTY: 'Sin datos disponibles',
        },
        COUNTRY: {
          TITLE: 'País',
          SOURCE: 'Perfiles de candidat@s inscritos · selección única',
          EMPTY: 'Sin datos disponibles',
        },
        CITY: {
          TITLE: 'Ciudad',
          LOCKED: 'Selecciona primero un país.',
          EMPTY: 'Sin ciudades disponibles para este país',
        },
        LANGUAGES: {
          TITLE: 'Idiomas',
          SOURCE: 'Idiomas de la oferta · nivel mínimo (≥)',
          EMPTY: 'No se han definido idiomas en esta oferta',
          SELECT_LANGUAGE: 'Selecciona un idioma para configurar el nivel mínimo',
          LEVEL_LABEL: 'Nivel mínimo',
          BASIC: 'Básico (A1-A2)',
          INTERMEDIATE: 'Intermedio (B1)',
          ADVANCED: 'Avanzado (B2-C1)',
          NATIVE: 'Nativo (C2)',
        },
        HARD_SKILLS: {
          TITLE: 'Aptitudes Técnicas (hard skills)',
          EMPTY: 'Sin datos disponibles',
        },
        SOFT_SKILLS: {
          TITLE: 'Aptitudes Interpersonales (soft skills)',
          EMPTY: 'Sin datos disponibles',
        },
        OTHER_COMP: {
          TITLE: 'Otras competencias',
          EMPTY: 'Sin datos disponibles',
        },
        INTERVIEW: {
          TITLE: 'Entrevista',
          INTERVIEW_ANSWERED: 'Respondida',
          INTERVIEW_SENT: 'Enviada',
          INTERVIEW_PENDING_SEND: 'No enviada',
        },
        CLASSIFICATION: {
          TITLE: 'Valoración',
          NO_CLASSIFICATION: 'Sin valorar',
          MIN_HINT: 'Pulsa la misma estrella para eliminar la valoración.',
        },
        MINIMUM_REQUIREMENTS: {
          TITLE: 'Requisitos mínimos',
          FORMATION: 'Formación',
          EXPERIENCE: 'Experiencia',
          OTHER: 'Otros',
        },
        DESIRED_REQUIREMENTS: { TITLE: 'Requisitos deseados' },
        STATUS: {
          TITLE: 'Etapa',
          ENROLLED: 'Por revisar',
          IN_PROCESS: 'Preseleccionad@s',
          SELECTED: 'Finalistas',
          DISCARDED: 'Descartad@s',
        },
        OTHER: { TITLE: 'Otros Filtros' },
        COMPATIBILITY: {
          TITLE: 'Coincidencia IA',
          ANY: 'Cualquiera',
          TOP_LABEL: '≥ 85%',
          HIGH_LABEL: '≥ 70%',
          POTENTIAL_LABEL: '< 70%',
          TOP: 'Match perfecto',
          TOP_RANGE: '85% o más · Perfil ideal para la oferta',
          HIGH: 'Muy buen encaje',
          HIGH_RANGE: 'Entre 70% y 85% · Cubre los puntos clave',
          POTENTIAL: 'Candidat@ con potencial',
          POTENTIAL_RANGE: 'Debajo de 70% · Vale la pena explorar',
        },
        DISCARD_INVERSE: {
          BUTTON: 'Descartar',
          TOOLTIP: 'Descarta a l@s candidat@s según tengan o no los filtros seleccionados.',
          DISABLED_TOOLTIP: 'Para descartar candidat@s activa al menos un filtro.',
          MATCHING: {
            LABEL: 'Descartar coincidencias',
            DESCRIPTION: 'Descartar a l@s candidat@s que <b>SÍ</b> cumplen con los filtros seleccionados.',
          },
          NOT_MATCHING: {
            LABEL: 'Descartar no coincidentes',
            DESCRIPTION: 'Descartar a l@s candidat@s que <b>NO</b> cumplen con los filtros seleccionados.',
          },
          CONFIRM: {
            TITLE: 'Confirmar descarte',
            QUESTION_MATCHING_SINGULAR: '¿Confirmas que deseas descartar a 1 candidat@ que <b>SÍ</b> cumple con estos requisitos?',
            QUESTION_MATCHING_PLURAL: '¿Confirmas que deseas descartar a {{count}} candidat@s que <b>SÍ</b> cumplen con estos requisitos?',
            QUESTION_NOT_MATCHING_SINGULAR: '¿Confirmas que deseas descartar a 1 candidat@ que <b>NO</b> cumple con estos requisitos?',
            QUESTION_NOT_MATCHING_PLURAL: '¿Confirmas que deseas descartar a {{count}} candidat@s que <b>NO</b> cumplen con estos requisitos?',
            RECOVER_NOTE_SINGULAR: 'Podrás recuperarl@ desde “Descartad@s” cuando quieras.',
            RECOVER_NOTE_PLURAL: 'Podrás recuperarl@s desde “Descartad@s” cuando quieras.',
            CANCEL: 'Cancelar',
            CONFIRM: 'Descartar',
          },
          NOTIFICATION: {
            TITLE: 'Descarte por filtros',
            SUCCESS: {
              TEXT_MATCHING: 'Se han descartado l@s candidat@s que tenían los filtros seleccionados.',
              TEXT_NOT_MATCHING: 'Se han descartado l@s candidat@s que no tenían los filtros seleccionados.',
            },
            ERROR: { TEXT: 'No se pudo completar el descarte. Inténtalo de nuevo.' },
            ALREADY_DISCARDED: {
              TITLE: 'L@s candidat@s ya están descartad@s',
              TEXT_MATCHING: 'L@s candidat@s que cumplen con los filtros seleccionados ya están en “Descartad@s”.',
              TEXT_NOT_MATCHING: 'L@s candidat@s que no cumplen con los filtros seleccionados ya están en “Descartad@s”.',
            },
            NONE_TO_DISCARD: {
              TITLE: 'No hay candidat@s para descartar',
              TEXT_MATCHING: 'Ningún candidat@ de esta etapa cumple con los filtros seleccionados.',
              TEXT_NOT_MATCHING: 'Tod@s l@s candidat@s de esta etapa cumplen con los filtros seleccionados.',
            },
          },
        },
      },
      TABLE: {
        TITLE: {
          ENROLLED: 'Por revisar',
          IN_PROCESS: 'Preseleccionad@s',
          SELECTED: 'Finalistas',
          SUGGESTED: 'Sugerid@s',
          DISCARDED: 'Descartad@s',
          ALL: 'Inscrit@s',
        },
        CONTACTED: {
          CARD: 'Contactad@',
          TOOLTIP: 'Este candidat@ ya ha sido contactad@ directamente por ti o alguien de tu empresa',
        },
        SUGGESTED_SEND_OFFER: { TOOLTIP: 'Este/a candidat@ se inscribió en esta oferta a través de una invitación enviada por ti o por alguien de tu empresa' },
        VIEW: 'Vista',
        VIEWS_TOOLTIP: 'Explora las 3 vistas disponibles para navegar entre candidat@s. Cada una te ofrece diferentes funciones para evaluar y organizar tu proceso',
        VIEW_LIST_TOOLTIP: 'Lista',
        VIEW_CARDS_TOOLTIP: 'Tarjetas',
        VIEW_WOKAP_TOOLTIP: 'wokap',
        HEADER: {
          NAME: 'Nombre',
          MATCH: 'Coincidencia',
          MATCH_TOOLTIP: 'Porcentaje de coincidencia con la oferta',
          NOTES: 'Notas',
          POSITION: 'Ocupación',
          CITY: 'Ciudad',
          COUNTRY: 'País',
          REQUIREMENTS_MINIMUM: 'R. Mín',
          REQUIREMENTS_MINIMUM_TOOLTIP: 'Requisitos mínimos',
          REQUIREMENTS_DESIRED: 'R. Des',
          REQUIREMENTS_DESIRED_TOOLTIP: 'Requisitos deseables',
          DATE: 'Postulación',
          DATE_TOOLTIP: 'Fecha en que la persona se inscribió a esta oferta',
          INTERVIEW: 'Entrevista',
          INTERVIEW_TOOLTIP: 'Estado de la entrevista',
          STATUS: 'Estado',
          CLASSIFICATION: 'Valoración',
          ACTIONS: 'Acciones Candidat@s',
        },
        ACTIONS: {
          SELECT: 'Avanzar a finalista',
          RESEND_INTERVIEW: 'Reenviar entrevista',
          SEND_INTERVIEW: 'Enviar entrevista',
          SEND_INTERVIEW_DISABLED_ANSWERED: 'Él/la candidat@ ya ha respondido la entrevista. Para verla, ingresa a su perfil',
          CREATE_INTERVIEW: 'Crear entrevista',
          SEND_MESSAGE: 'Enviar un mensaje',
          RESTORE: 'Recuperar candidat@',
          RESTORE_TOOLTIP: 'Recuperar candidat@ descartad@',
          INTERESTED: 'Preseleccionar',
          OPEN_CHAT: 'Enviar mensaje',
          DISCARD: 'Descartar candidat@',
          FINAL_INTERVIEW_MODAL: 'Gestionar Candidat@',
          FINAL_INTERVIEW_MODAL_TOOLTIP: 'Agenda y contacta',
          NOTES: 'Notas',
          ADVANCE: 'Avanzar candidat@ a la siguiente etapa',
          ADVANCE_DISABLED_DISCARDED: 'No puedes avanzar a candidat@ descartad@',
          ADVANCE_ERROR: {
            TITLE: 'No se puede avanzar',
            MESSAGE: 'No puedes avanzar candidat@s que están descartad@s. Por favor, desmarque l@s candidat@s descartad@s e intenta de nuevo.',
          },
          MOVE: 'Mover candidat@',
          SEND_QUESTION: 'Preguntas directas a candidat@',
          SEND_QUESTION_TOOLTIP: 'Enviarle preguntas directas a candidat@',
          SEND_QUESTION_TOOLTIP_MULTIPLE: 'Enviarles preguntas directas a l@s candidat@s',
          DISABLED_MULTIPLE_SELECTION: 'Deselecciona candidat@s para usar acciones individuales',
          SPECIFIC_QUESTIONS: {
            HEADER: 'Preguntas Directas',
            DESCRIPTION: 'Estas preguntas se enviarán a el/la candidat@ y las responderá en video. Es casi como tenerl@ frente a ti: al leer la pregunta, tiene solo 1–2 segundos antes de grabar su respuesta. Aprovecha esta potente herramienta para evaluar de forma auténtica y natural.',
            DESCRIPTION_MULTIPLE: 'Estas preguntas se enviarán a l@s candidat@s y las responderán en video. Es casi como tenerl@s frente a ti: al leer la pregunta, tienen solo 1–2 segundos antes de grabar su respuesta. Aprovecha esta potente herramienta para evaluar de forma auténtica y natural.',
            QUESTION_LABEL: 'Pregunta {{ number }}',
            ADD_BUTTON: 'Añadir pregunta',
            SEND_BUTTON: 'Enviar',
            AI: {
              SUBTITLE: 'Genera preguntas directas con IA a partir de tu oferta. Podrás editarlas antes de enviarlas.',
              COUNT_LABEL: 'Número de preguntas',
              COUNT_PLACEHOLDER: 'Escoge el número de preguntas',
              TOPIC_LABEL: '¿Sobre qué tema quieres dirigirlas? (opcional)',
              TOPIC_PLACEHOLDER: 'Ej.: disponibilidad, experiencia con clientes, motivación...',
              SUGGESTIONS: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                1: 'Disponibilidad y fecha de incorporación',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                2: 'Expectativas salariales',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                3: 'Motivación por el puesto',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                4: 'Experiencia en roles similares',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                5: 'Trabajo en equipo',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                6: 'Manejo de presión o retos',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                7: 'Nivel de idiomas',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                8: 'Conocimientos técnicos clave',
              },
              GENERATE_BUTTON: 'Generar preguntas con IA',
              MANUAL_BUTTON: 'Escribirlas yo',
              BACK_TO_OPTIONS: 'Volver a opciones de IA',
              LOADING: 'Generando preguntas directas con IA...',
              ERROR: 'No se pudieron generar las preguntas. Inténtalo de nuevo o escríbelas tú.',
            },
          },
          DUPLICATE_LIMIT_MODAL: {
            SUMMARY: 'Límite alcanzado',
            DETAIL: 'Puedes añadir un máximo de 5 preguntas.',
          },
          SEND_QUESTION_SUCCESS_MODAL: {
            SUMMARY: 'Éxito',
            DETAIL: 'Preguntas enviadas correctamente.',
          },
          SEND_QUESTION_FAILURE_MODAL: {
            SUMMARY: 'Error',
            DETAIL: 'Hubo un error al enviar las preguntas.',
          },
        },
        CARD: {
          REQUIREMENTS_MINIMUM: 'R. Mínimos ({{ requirements_required }})',
          REQUIREMENTS_DESIRED: 'R. Deseables ({{ requirements_desired }})',
        },
        ACTION_MULTIPLE: {
          SELECTED: 'Seleccionad@',
          SELECTED_PLURAL: 'Seleccionad@s',
        },
        ENROLLED: {
          TITLE: 'Candidat@s Por revisar',
          INFO: 'En esta sección se agrupan l@s candidat@s que aún no han sido evaluad@s ni asignad@s a ninguna etapa. Es el primer paso del proceso: consulta sus perfiles y decide si avanzan, se descartan o permanecen aquí por el momento.',
        },
        IN_PROCESS: {
          TITLE: 'Candidat@s Preseleccionad@s',
          INFO: 'Aquí están l@s candidat@s que has decidido avanzar en el proceso. Desde esta vista puedes evaluarl@s más a fondo y hacer un primer contacto o enviarles la entrevista inicial.',
        },
        SELECTED: {
          TITLE: 'Candidat@s Finalistas',
          INFO: 'Este apartado reúne a l@s candidat@s que han llegado a la etapa final. Aquí puedes comparar perfiles, dejar notas específicas, comunicarte con ell@s y definir quién será la persona seleccionada.',
        },
        SUGGESTED: {
          TITLE: 'Candidat@s Sugerid@s',
          INFO: 'Adicionalmente a l@s candidat@s que ya se inscribieron a tu oferta, wokap te sugiere est@s otros candidat@s. Revisa sus perfiles y, si algun@ te interesa, invítal@s a inscribirse para gestionarl@s e incluirl@s en tu proceso de selección.',
        },
        DISCARDED: {
          TITLE: 'Candidat@s Descartad@s',
          INFO: 'En esta sección encontrarás a l@s candidat@s que fueron descartad@s durante alguna etapa del proceso. Puedes registrar el motivo del descarte para futuras referencias o auditorías internas.',
        },
        ALL: {
          TITLE: 'Candidat@s Inscrit@s',
          INFO: 'Aquí encontrarás a tod@s l@s candidat@s que han aplicado a la oferta de trabajo, sin importar en qué etapa se encuentren. Esta vista global te permite consultar sus perfiles, seguir su evolución y aplicar filtros para gestionar el proceso de forma integral.',
        },
        NO_DATA: 'Aún no tienes ningún candidat@ en este paso del proceso y filtros aplicados',
      },
      NEW_CANDIDATES: {
        TITLE: 'Nuev@s candidat@s',
        SUBTITLE: '{{amount}} nuev@s candidat@s han respondido a tu oferta',
        NO_DATA: 'Ningún candidat@ ha respondido a tu oferta',
        ACTIONS: {
          DEFAULT: 'Todos los requisitos',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          1: 'Requisito 1',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          2: 'Requisito 2',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          3: 'Requisito 3',
        },
      },
      TIKTOK_VIEW: { TITLE: 'Vista wokap' },
      SUGGESTED_CANDIDATES: {
        TITLE: 'Candidat@s sugerid@s',
        SUBTITLE: '{{amount}} nuev@s candidat@s podrían encajar en tu oferta.',
        SUBTITLE_SINGULAR: '{{amount}} nuev@ candidat@ podría encajar en tu oferta.',
        NO_DATA: 'Por ahora no hay candidat@s que coincidan con tu oferta.\n' +
          'Pero todos los días se suman más personas a wokap;\n' +
          'tan pronto haya perfiles que encajen con tu vacante, los verás aquí.',
        MODAL: {
          TITLE: 'Candidat@ sugerid@',
          CANCEL: 'Descartar',
          CONFIRM: 'Invitar a la oferta',
          CONFIRM_TOOLTIP: 'Invita a esta persona a inscribirse en la oferta. Cuando lo haga, podrás gestionar su proceso',
          ALREADY_SENT: 'Tú o alguien de tu empresa ya invitó a esta persona a inscribirse en la oferta. Cuando acepte la invitación, podrás gestionar su proceso',
          VIEW_CANDIDATE: 'Ver candidat@',
          MODAL_CONFIRMATION: {
            HEADER: 'Enviar invitación',
            CONTENT: '¿Confirmas que deseas invitar a esta persona para que aplique a tu vacante de {{offer}}?',
            CONFIRM: 'Invitar a la oferta',
            CANCEL: 'Cancelar',
          },
        },
      },
      MODAL_CANDIDATES: {
        TITLE: 'Candidat@',
        SHOW_MORE: 'Ver más',
      },
      OFFER_CHANGE_STATUS_CORRECTLY: 'La oferta ha cambiado de estado correctamente.',
      CANDIDATE_DISCARDED_CORRECTLY: 'El candidat@ ha sido descartad@ correctamente.',
      INTERVIEW_SENT_CORRECTLY: 'La oferta ha sido enviada correctamente al candidat@.',
      PREVIEW: {
        CONTRACT_TYPE: { TITLE: 'Tipo de empleo' },
        LOCATION: { TITLE: 'Sucursal' },
        TYPE: { TITLE: 'Modalidad' },
        SALARY: { TITLE: 'Salario' },
        WORKING_DAY: { TITLE: 'Tipo de jornada' },
        REQUIREMENTS_MINIMUM: {
          TITLE: 'Requisitos mínimos',
          FORMATION: {
            TITLE: 'Formación',
            EMPTY: 'No hay formación requerida',
          },
          EXPERIENCE: {
            TITLE: 'Experiencia',
            EMPTY: 'No hay años de experiencia requeridos',
          },
          OTHER: {
            TITLE: 'Otros',
            EMPTY: 'No hay otros requisitos requeridos',
          },
          LANGUAGES: {
            TITLE: 'Idiomas',
            EMPTY: 'No hay idiomas requeridos',
          },
        },
        REQUIREMENTS_DESIRED: {
          TITLE: 'Requisitos deseados',
          LANGUAGES: {
            TITLE: 'Idiomas',
            EMPTY: 'No hay idiomas deseados',
          },
          EXPERIENCE: {
            TITLE: 'Experiencia',
            EMPTY: 'No hay años de experiencia deseados',
          },
          OTHER: {
            TITLE: 'Otros',
            EMPTY: 'No hay otros requisitos deseados',
          },
          EMPTY: 'No hay requisitos deseados',
        },
        DESCRIPTION: 'Descripción',
        INTERVIEW: 'Entrevista',
        QUESTIONS: '{{ number }} preguntas',
        EDIT_DESCRIPTION_SUCCESS: 'Descripción editada correctamente.',
      },
      FINAL_INTERVIEW_MODAL: {
        TITLE: 'Gestionar Candidat@',
        TITLE_ALT: 'Agenda y contacta',
        AGENDA_OVERLAY: {
          OPTION_INTERVIEW: 'Agendar cita presencial o virtual',
          OPTION_DOCUMENTS: 'Solicitar documentos',
          OPTION_VIRTUAL_TEST: 'Enviar formularios / cuestionarios',
          OPTION_CONTACT: 'Solicitar que contacten contigo',
          OPTION_CUSTOM_MESSAGE: 'Mensaje personalizado',
          INTERVIEW_BULK_TOOLTIP: 'Las citas se agendan de forma individual. Selecciona un solo candidat@. Si quieres incluir a varios candidat@s en una misma reunión, deberás agendarl@s un@ por un@.',
        },
        STEP_INTRO: 'Estás en el paso final de tu preselección.',
        FINALISTS_INTRO: 'Ya tienes a tus candidat@s finalistas.',
        ACTION_INTRO: 'Ahora, elige cómo quieres avanzar con cada un@.',
        EDIT_INSTRUCTION: 'Selecciona la acción que quieres realizar:',
        SENT_MESSAGE: 'Mensaje enviado correctamente',
        CALENDAR_CONFIRM: {
          TITLE: 'Agendar en calendario',
          MESSAGE: '¿Quieres agendar este evento en tu calendario?',
        },
        RE_SEND_CONFIRM: {
          TITLE: 'Reenviar entrevista',
          MESSAGE: '¿Quieres reenviar la entrevista a los candidat@s con las preguntas actualizadas?',
        },
        MESSAGE: {
          HEADER: 'Hola, nos interesa tu perfil y quisiéramos conocerte mejor.',
          FOOTER: '¡Que tengas un excelente día!',
        },
        ERROR: { UNSAVED_CHANGES: 'Tienes cambios sin guardar. Guarda o cancela la edición antes de continuar.' },
        CONFIRM_SECTION_CHANGE: {
          HEADER: 'Cambios sin guardar',
          MESSAGE: 'Tienes cambios sin guardar en esta sección. ¿Qué deseas hacer?',
          SAVE_AND_CONTINUE: 'Guardar y cambiar',
          DISCARD_AND_CONTINUE: 'Descartar cambios',
          CANCEL: 'Quedarse aquí',
        },
        CONFIRM_CLOSE: {
          HEADER: 'Cambios sin guardar',
          MESSAGE: 'Tienes cambios sin guardar. ¿Qué deseas hacer antes de cerrar?',
          SAVE_AND_CLOSE: 'Guardar y cerrar',
          DISCARD_AND_CLOSE: 'Descartar y cerrar',
          CANCEL: 'Seguir editando',
        },
        INTERVIEW: {
          TITLE: 'Queremos agendar una entrevista contigo:',
          DAY: 'Día',
          TIME: 'Hora',
          DATE_TIME: 'Fecha y Hora',
          SELECT_DATE_TIME: 'Selecciona la fecha y hora de la entrevista',
          TIME_SELECTOR_INFO: 'Usa los selectores de abajo para ajustar la hora',
          ACCEPT: 'Aceptar',
          CLEAR: 'Limpiar',
          CANCEL: 'Cancelar',
          TODAY: 'Hoy',
          FORMAT: 'Formato',
          FORMAT_OPTIONS: {
            VIRTUAL: {
              LABEL: 'Virtual',
              LOCATION: 'Link para reuniones virtuales',
            },
            IN_PERSON: {
              LABEL: 'Presencial',
              LOCATION: 'Ubicación para entrevistas presenciales',
            },
          },
          MANAGE_DATA_BUTTON: 'Configurar tus datos',
          MANAGE_DATA_TOOLTIP: 'Ahorra tiempo y evita repetir la misma información en cada contacto. Configura tus datos en wokap para que se autocompleten automáticamente en tus mensajes a candidat@s. Cada miembro del equipo configura sus propios datos. A continuación, configura los tuyos.',
          CALENDAR_EVENT_TITLE: 'Reunión con {candidateName} para la oferta {offerTitle}',
          MESSAGE_TEMPLATE: 'Queremos agendar una entrevista contigo:\n\nDía:\t\t{{day}}\nHora:\t\t{{time}}\nFormato:\t{{format}}\n{{locationFormat}}:\t{{location}}\n\nConfírmanos por este medio, por favor.',
          CALENDAR_WARNING: {
            MESSAGE: 'El candidato no recibirá la invitación de calendario hasta que conectes tu calendario.',
            LINK: 'Conectar calendario',
          },
        },
        DOCUMENTS: {
          TITLE: 'Por favor, envíanos por este medio los siguientes documentos:',
          DOCUMENTS: 'Documentos requeridos',
          MESSAGE_TEMPLATE: 'Por favor, envíanos por este medio los siguientes documentos:\n\n{{documents}}',
        },
        VIRTUAL_TEST: {
          TITLE: 'Por favor, completa lo siguiente:',
          TECHNICAL_TEST: 'Escribe el link de la prueba técnica o cuestionario',
        },
        CONTACT: {
          TITLE: 'Por favor, contáctanos:',
          WHATSAPP: 'Por WhatsApp',
          PHONE: 'Por llamada',
          CONTACT_PERSON: 'Persona de contacto',
          EMAIL: 'Por Email',
          MANAGE_DATA_BUTTON: 'Configurar tus datos',
          MANAGE_DATA_TOOLTIP: 'Ahorra tiempo y evita repetir la misma información en cada contacto. Configura tus datos en wokap para que se autocompleten automáticamente en tus mensajes a candidat@s. Cada miembro del equipo configura sus propios datos. A continuación, configura los tuyos.',
        },
        CUSTOM_MESSAGE: {
          TITLE: 'Mensaje personalizado:',
          CUSTOM_MESSAGE: 'Escribe aquí el mensaje.',
          MESSAGE_TEMPLATE: '\n{{customMessage}}',
        },
        SEND_MESSAGE: 'Enviar mensaje',
        MESSAGE_PREVIEW: 'Previsualización del mensaje',
      },
      DIRECT_MESSAGE_CONFIG_MODAL: {
        HEADER: 'Configurar textos de mensaje directo',
        TOOLTIP: 'Configurar mensajes',
        INTRO_LABEL: 'Introducción del mensaje',
        INTRO_PLACEHOLDER: 'Ej: Hola, nos interesa tu perfil y quisiéramos conocerte mejor.',
        INTRO_HELP: 'Este texto aparecerá automáticamente al inicio de todas tus comunicaciones de esta sección. Puedes modificarlo cuando quieras.',
        SUFFIX_LABEL: 'Cierre del mensaje',
        SUFFIX_PLACEHOLDER: 'Ej: ¡Que tengas un excelente día!',
        SUFFIX_HELP: 'Este texto aparecerá automáticamente al final de todas tus comunicaciones de esta sección. Puedes modificarlo cuando quieras.',
        SAVE_SUCCESS: 'Configuración guardada correctamente.',
        ERROR_LOAD: 'Error al cargar la configuración',
      },
      EXPANDABLE_CARD: {
        SEE_MORE: 'Ver más',
        SEE_LESS: 'Ver menos',
      },
      CONFIRM_DUPLICATE: {
        HEADER: 'Duplicar oferta',
        MESSAGE: '¿Estás segur@ que deseas duplicarla?',
        ACCEPT: 'Duplicar',
        REJECT: 'Cancelar',
      },
      DUPLICATING: {
        TITLE: 'Duplicando',
        MESSAGE: 'La oferta está siendo duplicada. Te notificaremos y redirigiremos cuando esté lista.',
      },
      CANDIDATE_MOVED_SUCCESSFULLY: 'Candidat@ movido correctamente.',
      CANDIDATES_MOVED_SUCCESSFULLY: 'Candidat@s movidos correctamente.',
      CONFIRM_MOVE: {
        HEADER: '¿Confirmas que deseas mover a este candidat@?',
        ACCEPT: 'Mover',
        REJECT: 'Cancelar',
      },
      CONFIRM_MOVE_MULTIPLE: { HEADER: '¿Confirmas que deseas mover a estos {{count}} candidat@s?' },
    },
    CREATE: {
      STEP_1: {
        HELLO: '¡Hola {{ username }}!',
        TITLE_CREATE: 'Crea una oferta de empleo',
        TITLE_EDIT: 'Editar la oferta de empleo',
        SELECT_LOCATION: 'Selecciona la ubicación',
        LOCATION_MODE_QUESTION: '¿Para qué ubicación es esta oferta?',
        LOCATION_MODE_EXISTING: 'Sucursal existente',
        LOCATION_MODE_NEW: 'Nueva sucursal',
        LOCATION_AUTO_PLACEHOLDER: 'Este campo se autocompleta al ingresar la ubicación',
        LOCATION_STATE_NOT_DETECTED_ERROR: 'Selecciona una dirección más precisa para que este campo se autocomplete.',
        NO_BRANCHES_FOUND: 'No se encontraron sucursales',
        OFFER: 'Oferta de empleo',
        OFFER_DESCRIPTION: '¿Tienes ya una oferta o descripción del puesto? <br/>Si no, la creamos por ti.',
        FORM: {
          LABEL: {
            BRANCH: 'Sucursal',
            BRANCH_ADDRESS: 'Dirección de la sucursal',
            CREATE_NEW_BRANCH: 'Si la sucursal que buscas no está en la lista.',
            CREATE_NEW_BRANCH_SUBTITLE: 'Haz click aquí para crear una nueva.',
            NEW_BRANCH_NAME: 'Nombre de la nueva sucursal',
            CITY: 'Ciudad',
            OFFER_TITLE: 'Título de la oferta',
            TYPE: 'Modalidad',
            CONTRACT_TYPE: 'Tipo de empleo',
            WORKING_DAY: 'Tipo de jornada',
            OFFER_SALARY: 'Información salarial (Opcional)',
            OFFER_SALARY_SUBTITLE: 'Publicar el salario puede aumentar la cantidad y calidad de las postulaciones.',
          },
          PLACEHOLDER: {
            BRANCH_CITY: 'Selecciona la ciudad',
            BRANCH_DROPDOWN: 'Selecciona una sucursal',
            NEW_BRANCH_NAME: 'Escribe el nombre de la sucursal',
            CITY: 'Escribe la ciudad de la nueva sucursal',
            BRANCH_SEARCH: 'Busca o escribe el nombre de una sucursal',
            OFFER_TITLE: 'Ej. Diseñador industrial',
            TYPE: 'Selecciona una modalidad',
            CONTRACT_TYPE: 'Selecciona un tipo de empleo',
            WORKING_DAY: 'Selecciona un tipo de jornada',
            OFFER_SALARY: '25,000 a 30,000 € al año',
            OFFER_DESCRIPTION: 'Pega aquí la descripción',
            ADDRESS: 'Introduce la ubicación de la nueva sucursal',
            ADDRESS_HINT: 'Escribe una dirección y selecciona una de las opciones sugeridas.',
            COUNTRY_HINT: 'Se autocompleta al seleccionar la ubicación en el mapa.',
            STATE_HINT: 'Se autocompleta al seleccionar la ubicación en el mapa.',
            CITY_HINT: 'Se autocompleta al seleccionar la ubicación o puedes escribirla manualmente.',
          },
          MODAL_MAP: { TITLE: 'Vista de mapa' },
        },
        INFO: 'Establecer un rango salarial aumenta la recepción de candidat@s y ayuda a tu empresa a ser más honesta y transparente.',
        FORM_ERRORS: { GLOBAL: 'Revisa el formulario: hay errores o campos obligatorios pendientes.' },
        DIALOG: {
          HEADER: 'Cancelar creación de la oferta',
          HEADER_EDIT: 'Cancelar edición de la oferta',
          MESSAGE: '¿Estás segur@ que deseas cancelar la creación de la oferta? Los datos se perderán.',
          MESSAGE_EDIT: '¿Estás segur@ que deseas cancelar la edición de la oferta? Los datos se perderán.',
          ACCEPT: 'Continuar',
          ACCEPT_EDIT: 'Cancelar edición',
          REJECT: 'Volver',
          REJECT_EDIT: 'Seguir editando',
        },
        GUARD: {
          EDITION_HEADER: 'Cancelar creación de la oferta',
          EDITION_MESSAGE: '¿Estás segur@ que deseas cancelar la creación de la oferta? Los datos se perderán.',
          EDITION_ACCEPT: 'Cancelar creación',
          EDITION_REJECT: 'Seguir creando',
        },
      },
      STEP_2: {
        TITLE: 'Requerimientos mínimos',
        INFO: 'Son aquellos requisitos <b>indispensables</b> para desempeñar el puesto de trabajo.',
        FORM: {
          LABEL: {
            EXPERIENCE: 'Experiencia',
            FORMATION: 'Formación',
            OTHER: 'Otros requisitos',
          },
          PLACEHOLDER: {
            EXPERIENCE: 'Más de 5 años de gestión de proyectos',
            FORMATION: 'Grado en Ingeniería de datos en UNIOVI',
            OTHER: 'Ej: nivel alto Wordpress',
          },
          LANGUAGE: {
            LABEL: {
              LANGUAGE: 'Idioma',
              LEVEL: 'Nivel',
              CERTIFICATION: 'Certificación Internacional (Opcional)',
            },
            PLACEHOLDER: {
              LANGUAGE: 'Selecciona un idioma',
              LEVEL: 'Selecciona un nivel',
              CERTIFICATION: 'No necesaria',
            },
            LEVEL: {
              BASIC: 'Básico',
              INTERMEDIATE: 'Intermedio',
              ADVANCED: 'Avanzado',
              NATIVE: 'Nativo',
            },
            CERTIFICATION: {
              NONE: 'No necesaria',
              A1: 'A1 (Principiante)',
              A2: 'A2 (Básico)',
              B1: 'B1 (Intermedio)',
              B2: 'B2 (Intermedio alto)',
              C1: 'C1 (Avanzado)',
              C2: 'C2 (Maestría)',
            },
          },
        },
        LANGUAGES: 'Idiomas',
        YEARS_EXPERIENCE: 'Años de experiencia',
        OTHER: 'Otros requisitos',
        ADD_LANGUAGE: 'Añadir idioma',
        SAVE_LANGUAGE: 'Guardar idioma',
        DELETE_LANGUAGE: 'Eliminar idioma',
        ADD: 'Añadir',
        DIALOG: {
          HEADER: 'Faltan requisitos mínimos',
          MESSAGE: 'No has especificado ningún requisito mínimo para la oferta. Estos criterios son esenciales para asegurar que los candidat@s cumplan con las expectativas básicas. ¿Estás segur@ que deseas continuar sin añadir estos requisitos mínimos?',
          ACCEPT: 'Continuar',
          REJECT: 'Volver',
        },
        ERRORS: {
          AT_LEAST_ONE_REQUIRED: 'Debes agregar al menos un requisito mínimo en alguno de los cuatro campos.',
          LANGUAGE_PENDING: 'Hay un idioma sin completar. Elimínalo, o complétalo y guárdalo para continuar.',
          LANGUAGE_REQUIRED: 'Selecciona un idioma.',
          LEVEL_REQUIRED: 'Selecciona un nivel.',
        },
        SUGGESTED_CHIPS: {
          WORKGROUP: 'Trabajo en equipo',
          PUNCTUALITY: 'Puntualidad',
          RESPONSIBILITY: 'Responsabilidad',
          PROACTIVITY: 'Proactividad',
          ADAPTABILITY: 'Adaptabilidad',
          ORGANIZATION: 'Organización',
          PROBLEM_SOLVING: 'Resolución de problemas',
          ATTENTION_TO_DETAIL: 'Atención al detalle',
          ONE_YEAR_EXPERIENCE: '1 Año de experiencia',
          WORK_UNDER_PRESSURE: 'Capacidad para trabajar bajo presión',
        },
      },
      STEP_3: {
        TITLE: 'Requerimientos deseados ',
        INFO: 'Son aquellos requisitos <b>no esenciales</b>, pero que pueden ser <b>un plus</b> para el/la candidat@.',
        FORM: { PLACEHOLDER: { REQUIREMENTS: 'Ej: nivel alto Wordpress' } },
        LANGUAGES: 'Idiomas',
        YEARS_EXPERIENCE: 'Años de experiencia',
        OTHER: 'Otros requisitos',
        ADD_LANGUAGE: 'Añadir idioma',
        ADD: 'Añadir',
        OPTIONAL_STEP: 'Este paso es opcional.',
        DIALOG: {
          HEADER: '¿Volver a generar la descripción?',
          MESSAGE: 'Presiona “Sí” si quieres generar nuevamente la descripción.<br /> Presiona “No” para continuar con la descripción que ya tenía tu oferta.',
          ACCEPT: 'Si',
          REJECT: 'No',
        },
        SUGGESTED_CHIPS: {
          INDUSTRY_EXPERIENCE: 'Experiencia en el sector',
          LANGUAGES: 'Idiomas',
          LEADERSHIP: 'Liderazgo',
          DRIVERS_LICENSE: 'Carnet de conducir',
          FLEXIBLE_SCHEDULE: 'Flexibilidad horaria',
          CREATIVITY: 'Creatividad',
          EASY_LEARNER: 'Facilidad para aprender',
          GOOD_WRITING: 'Buena redacción',
          COMMUNICATION_SKILLS: 'Habilidades comunicativas',
        },
        LOADING_LOCATIONS: 'Cargando ubicaciones...',
      },
      STEP_4: {
        TITLE: '¡Genial!',
        INFO: 'Aquí tienes la descripción de la Oferta de Empleo para el puesto de <b>"{{ title }}"</b> generada en base a los datos introducidos anteriormente:',
        DESCRIPTION: 'Descripción',
        CHAT_PLACEHOLDER: 'Escribe un mensaje...',
        EDIT: 'Editar manualmente',
        SAVE: 'Guardar',
        AI_PROMPT: {
          PLACEHOLDER: 'Escribe aquí los cambios que quieres realizar en la descripción',
          OFFER_CHANGES: '¿Quieres hacer algún cambio sobre la descripción de la Oferta?',
        },
        SUGGESTED_CHIPS: {
          DESCRIBE_COMPANY: 'Describe de manera más extensa nuestra empresa',
          USE_FORMAL_LANGUAGE: 'Utiliza lenguaje más formal',
          // ADD_CHANGE_MANAGEMENT: 'Añade la responsabilidad de ajustar cambios',
          SHORTER_AND_DIRECT: 'Hazla más breve y directa',
          PROFESSIONAL_TONE: 'Usa un tono más profesional',
          REMOVE_GENERICS: 'Elimina las partes que suenen muy genéricas',
          YOUNG_CANDIDATES: 'Hazla más atractiva para candidat@s jóvenes',
          POSITION_BENEFITS: 'Especifica mejor los beneficios del puesto',
          SKILL_EMPHASIS: 'Enfatiza en las habilidades más importantes',
          RELEVANT_AT_START: 'Cambia el orden para que lo más relevante esté al principio',
        },
      },
      STEP_5: {
        TITLE: 'Añade un video a tu oferta',
        SUBTITLE: 'Graba un video para tu vacante y hazla más atractiva para l@s candidat@s. Cuenta qué hace especial a tu empresa y qué buscas en el/la candidat@ ideal. Usa el texto de tu oferta como guía para grabar el video.',
        SUBTITLE_LINK: 'Ver texto oferta',
        CONTINUE_WITHOUT_VIDEO: 'Continuar sin video',
        UPLOAD_VIDEO: 'Subir video',
        REPLACE_VIDEO: 'Reemplazar video',
        SKIP: 'Continuar',
        CONTINUE: 'Continuar',
        UPLOAD_VIDEO_SUCCESS: 'Video subido correctamente.',
        UPLOAD_VIDEO_HELP: 'El video debe ser vertical y no superar los 50MB.',
        VIDEO_REQUIRED: 'Sube un video o marca la casilla',
      },
      STEP_6: {
        AI_PROMPT: {
          PLACEHOLDER: 'Escribe aquí los cambios que quieres realizar en las preguntas',
          OFFER_CHANGES: '¿Quieres hacer algún cambio sobre la entrevista de la oferta?',
        },
        ERRORS: {
          TITLE: 'Error al generar la entrevista',
          QUESTIONS_EMPTY: 'Existen algunas preguntas vacías, por favor revisa las preguntas antes de continuar.',
          QUESTION_UNSAVED: 'Tienes una pregunta con cambios sin guardar. Pulsa "Quedarse" para guardarla o "Salir sin guardar" para descartar los cambios y continuar.',
        },
      },
      LOADING: {
        LOADING_OFFER: 'Cargando oferta de empleo...',
        PUBLISH_OFFER: 'No cierres esta página, estamos publicando tu oferta.',
        GENERATING_OFFER: 'Generando la descripción de la Oferta </br> de Empleo con IA.',
        GENERATING_DESCRIPTION: 'Generando la descripción de la Oferta de Empleo para el puesto de <b>"{{ title }}"</b>:',
        AI_INPUT_PLACEHOLDER: 'Usa la barra de IA para realizar cambios y sugerencias...',
      },
      TAGS_HELP: 'Presiona Coma o Enter para añadir una nueva etiqueta',
      LANDING: {
        GREETING: '¡Hola {{ username }}!',
        QUESTION: '¿Deseas crear una nueva oferta o duplicar una de tus ofertas existentes?',
        CREATE_NEW: 'Crear nueva oferta',
        DUPLICATE_EXISTING: 'Duplicar una oferta',
      },
      DUPLICATE: {
        TITLE: 'Presiona el botón “Duplicar oferta” en la oferta que deseas duplicar',
        BACK: 'Volver',
        DUPLICATE_BTN: 'Duplicar oferta (úsalo para tus ofertas recurrentes)',
      },
      TITLE_CREATE: 'Crea una oferta de empleo',
      TITLE_EDIT: 'Editar la oferta de empleo',
    },
    INTERVIEW: {
      LOADING: 'Generando la Entrevista para tu</br> Oferta de Empleo con IA',
      LOADING_MANUAL_CREATION: 'Preparando editor de entrevista...',
      AI_PROMPT: {
        PLACEHOLDER: 'Escribe aquí los cambios que quieres realizar en las preguntas',
        SUGGESTIONS: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          1: 'Quiero que las preguntas sean más extensas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          2: 'Utiliza lenguaje más formal',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          3: 'Cambia el orden: empieza con una fácil',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          4: 'Haz preguntas más enfocadas en habilidades prácticas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          5: 'Añade una sobre experiencia previa en roles similares',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          6: 'Incluye una sobre manejo de presión o retos',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          7: 'Hazlas más cercanas y menos formales',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          8: 'Pregunta por valores o formas de trabajo en equipo',
        },
      },
      SELECTION: {
        TITLE: 'Entrevista de trabajo',
        SUBTITLE: 'Con base en tu oferta de empleo, genera una entrevista que se enviará solo a l@s candidat@s que selecciones más adelante desde tu “Panel de ofertas” en wokap.',
        QUESTIONS: {
          LABEL: 'Número de preguntas',
          PLACEHOLDER: 'Escoge el número de preguntas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          1: '1 pregunta',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          2: '2 preguntas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          3: '3 preguntas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          4: '4 preguntas',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          5: '5 preguntas',
        },
        BUTTONS: {
          GENERATE: 'Generar entrevista con IA',
          MANUAL: 'Crear yo la entrevista',
          SKIP: 'En otro momento',
        },
      },
      QUESTIONS: {
        TITLE: '¡Genial!',
        INFO: 'Crea las preguntas que enviarás más adelante a l@s candidat@s que elijas entrevistar para el puesto de {{ title }} , desde tu “Panel de ofertas” en wokap.',
        INFO_IA: 'Aquí tienes algunas preguntas que podrás enviar desde tu “Panel de ofertas” en wokap, a l@s candidat@s que elijas entrevistar para el puesto de {{ title }}.',
        DEFAULT: 'Haz clic en el lápiz para crear las preguntas que quieres incluir en la entrevista.',
        QUESTION: 'Pregunta {{ number }}',
        ADD: '+ Añadir otra pregunta',
        DELETE: 'Eliminar',
      },
    },
    PREVIEW: {
      TITLE: 'Resumen de la oferta',
      SUMMARY: 'Resumen',
      REQUIREMENTS: 'Requisitos',
      OFFER: 'Oferta de empleo',
      REQUIREMENTS_MINIMUM: {
        TITLE: 'Requisitos mínimos',
        EXPERIENCE: 'Experiencia',
        FORMATION: 'Formación',
        OTHER: 'Otros requisitos',
        LANGUAGES: 'Idiomas',
      },
      REQUIREMENTS_DESIRED: { TITLE: 'Requisitos deseables' },
      INTERVIEW: {
        TITLE: 'Entrevista de trabajo',
        EMPTY: 'No se ha generado entrevista',
      },
      EDIT: 'Editar',
      PUBLISH: 'Publicar oferta',
      PUBLISH_SUCCESS: 'Oferta publicada satisfactoriamente.',
      DIALOG: {
        HEADER: 'Cancelar edición de la oferta',
        MESSAGE: '¿Estás segur@ que deseas cancelar la edición de la oferta? Los datos se perderán.',
        ACCEPT: 'Seguir editando',
        REJECT: 'Cancelar edición',
      },
      GUARD: {
        EDITION_HEADER: 'Cancelar creación de la oferta',
        EDITION_MESSAGE: '¿Estás segur@ que deseas cancelar la creación de la oferta? Los datos se perderán.',
        EDITION_ACCEPT: 'Cancelar creación',
        EDITION_REJECT: 'Seguir creando',
      },
    },
    COPY: {
      LINK_SUCCESS: 'Link de la oferta copiado al portapapeles.',
      DATA_SUCCESS: 'Datos de la oferta copiados al portapapeles. Puedes pegarlos directamente en LinkedIn u otras plataformas.',
      QR_SUCCESS: 'Código QR copiado al portapapeles como imagen.',
      DATA_TOOLTIP: 'Copia toda la información de la oferta para compartirla, pegarla o publicarla en otros sitios',
      LINK_TOOLTIP: 'Copia el link de la oferta',
      QR_TOOLTIP: 'Copia el código QR de la oferta para compartirlo, pegarlo o publicarlo en otros sitios',
      SECTION: {
        TITLE: 'Título de la oferta',
        TYPE: 'Modalidad',
        LOCATION: 'Ubicación',
        SALARY: 'Sueldo',
        WORKING_DAY: 'Tipo de jornada',
        CONTRACT_TYPE: 'Tipo de empleo',
        PRESENTATION: 'Presentación',
        MIN_REQUIREMENTS: 'Requisitos mínimos',
        FORMATION: 'Formación',
        EXPERIENCE: 'Experiencia',
        OTHER: 'Otros',
        LANGUAGES: 'Idiomas',
        DESIRED_REQUIREMENTS: 'Requisitos deseados',
        DESCRIPTION: 'Descripción',
        APPLY_HERE: 'Aplica aquí',
      },
    },
    // Ref: docs/libraries/Angular v18 Documentation.txt
    APP_PREVIEW: {
      NON_INTERACTIVE_TOOLTIP: 'Esta vista previa no es interactiva. Descarga la app para probar la experiencia completa.',
      COMPANY_VIEW: 'Ver empresa',
    },
    PUBLISH: {
      TITLE: '¡Oferta publicada correctamente!',
      FIRST_APPLICANTS_NOTICE: 'Te enviaremos un correo electrónico cuando se inscriban l@s primer@s 5 candidat@s.',
      SUBTITLE: 'Comparte tu oferta copiando el link, los datos o el código QR para publicarla en redes sociales, páginas web o donde tú quieras.',
      PREVIEW_INFO: 'Para ver cómo se mostrará tu oferta a l@s candidat@s, puedes descargar la app de wokap o utilizar la vista previa aquí abajo.',
      PREVIEW_BUTTON: 'Vista previa',
      EDIT_INFO: '¿Quieres hacer cambios? Edítala aquí mismo.',
      EDIT_BUTTON: 'Editar oferta',
      INFO: 'Gestiona tu oferta, entrevistas y candidat@s desde el "Panel de Ofertas" de wokap.',
      COPY_SUCCESS: 'Link de la oferta copiado al portapapeles.',
      COPY_ERROR: 'No se pudo copiar el link. Por favor, intenta de nuevo.',
      COPY_QR_ERROR: 'No se pudo copiar el código QR. Por favor, intenta de nuevo.',
      BUTTON: 'Ir a mi Oferta',
      BUTTON_PANEL: 'Ir a Panel de Ofertas',
      BUTTON_PLATFORMS: 'Publicar en Plataformas',
      SUGGESTED_MODAL: {
        HEADER: '¡wokapIA encontró candidat@s para ti!',
        MESSAGE: 'Hay perfiles que encajan con tu oferta. Encuéntralos en la sección de Candidat@s Sugerid@s.',
        ACCEPT: 'Ver candidat@s sugerid@s',
        REJECT: 'Ir a la oferta',
      },
    },
    CANDIDATE_DETAIL: {
      TITLE: 'Candidat@',
      OFFER_TITLE: 'Oferta: {{ offer }}',
      PENDING_CLASSIFICATION: 'Pendiente de clasificar',
      EDUCATION: 'Formación',
      WORK_EXPERIENCE: 'Experiencia',
      CURRICULUM: 'Currículum',
      DOWNLOAD_CV: 'Descargar',
      LANGUAGES: 'Idiomas',
      CANDIDATE: 'Candidat@',
      PRESENTATION: 'Presentación',
      QUESTION: 'Pregunta {{ num }}',
      SPECIFIC_QUESTIONS: { TITLE: 'Preguntas directas' },
      ACTIONS: {
        EVALUATION: {
          BUTTON: 'Valoración',
          CONFIRM: {
            TITLE: 'Valoración',
            CONFIRM: 'Aplicar',
          },
          NOTIFICATION: {
            TITLE: 'Valoración',
            SUCCESS: { TEXT: 'Candidat@ valorad@ correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al valorar al candidat@.' },
          },
        },
        CHAT: 'Chat',
        NOTES: {
          BUTTON: 'Notas',
          SIDEBAR: {
            TITLE: 'Notas',
            ADD: 'Añadir nota',
            NOTE: {
              PLACEHOLDER: 'Esta nota solo es visible para ti y tu equipo.\nEl/la candidat@ no puede verla.',
              EDIT: 'Editar',
              SAVE: 'Guardar',
              DELETE: 'Eliminar',
              DISCARD: 'Descartar',
              CREATED_BY: 'Anotado por ',
              CREATED_BY_ME: 'Anotado por ti ',
            },
            SUCCESS: { COMMENT_DELETED: 'Nota eliminada correctamente' },
            ERRORS: {
              APPLY_OFFER_NOT_FOUND: 'La oferta seleccionada no existe',
              COMMENT_NOT_BLANK: 'El comentario no puede estar vacío',
              APPLY_OFFER_COMMENT_NOT_FOUND: 'El comentario de la oferta no existe',
              COMMENT_NOT_CREATED_BY_YOU: 'El comentario no ha sido creado por ti',
            },
          },
        },
        BACK_TO_REVIEW: {
          BUTTON: 'Mover candidat@',
          CONFIRM: {
            TITLE: 'Avanzar candidat@',
            MESSAGE: '¿Confirmas que deseas avanzar a el/la candidat@ a la siguiente etapa?',
            CONFIRM: 'Avanzar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Avanzar candidat@s',
            MESSAGE: '¿Confirmas que deseas avanzar a est@s candidat@s a la siguiente etapa?',
            CONFIRM: 'Avanzar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Movid@',
            SUCCESS: { TEXT: 'Candidat@ movid@ correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al iniciar el proceso.' },
          },
        },
        START_PROCESS: {
          BUTTON: 'Preseleccionar',
          CONFIRM: {
            TITLE: 'Preseleccionar',
            MESSAGE: '¿Confirmas que deseas avanzar con est@ candidat@ en el proceso de selección?',
            CONFIRM: 'Avanzar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Preseleccionar',
            MESSAGE: '¿Confirmas que deseas avanzar a est@s candidat@s en el proceso de selección?',
            CONFIRM: 'Avanzar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Realizado',
            SUCCESS: { TEXT: 'El proceso se ha realizado correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al iniciar el proceso.' },
          },
        },
        SEND_INTERVIEW: {
          BUTTON: 'Enviar entrevista',
          BUTTON_NO_INTERVIEW: 'Iniciar proceso',
          CONFIRM: {
            TITLE: 'Enviar entrevista',
            MESSAGE: '¿Estás segur@ que deseas enviar la entrevista a est@ candidat@?',
            CONFIRM: 'Enviar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Enviar entrevistas',
            MESSAGE: '¿Estás segur@ que deseas enviar las entrevistas a est@s candidat@s?',
            CONFIRM: 'Enviar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Enviada',
            SUCCESS: { TEXT: 'La entrevista ha sido enviada correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al enviar la entrevista al candidat@.' },
          },
        },
        RE_SEND_INTERVIEW: {
          BUTTON: 'Reenviar entrevista',
          CONFIRM: {
            TITLE: 'Reenviar entrevista',
            MESSAGE: 'La entrevista ya fue enviada a est@ candidat@, pero aún no la ha respondido.<br/><br/> Haz clic en Reenviar.',
            CONFIRM: 'Reenviar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Reenviar entrevistas',
            MESSAGE: 'La entrevista ya fue enviada a est@s candidat@s, pero aún no la han respondido.<br/><br/>  Haz clic en Reenviar.',
            CONFIRM: 'Reenviar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Reenviada',
            SUCCESS: { TEXT: 'La entrevista ha sido reenviada correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al reenviar la entrevista al candidat@.' },
          },
        },
        SELECT: {
          BUTTON: 'Avanzar a finalista',
          CONFIRM: {
            TITLE: 'Avanzar candidat@',
            MESSAGE: '¿Confirmas que deseas avanzar a est@ candidat@ a la siguiente etapa?',
            CONFIRM: 'Avanzar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Avanzar candidat@s',
            MESSAGE: '¿Confirmas que deseas avanzar de est@s candidat@s a la siguiente etapa?',
            CONFIRM: 'Avanzar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Avanzar a finalista',
            SUCCESS: { TEXT: 'Candidat@ avanzad@ a finalista correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al avanzar a finalista a candidat@.' },
          },
        },
        DISCARD: {
          BUTTON: 'Descartar',
          DISCARDED_NOTE_PREFIX: 'CANDIDAT@ DESCARTAD@ POR:',
          CONFIRM: {
            TITLE: 'Descartar candidat@',
            MESSAGE: '¿Estás segur@ que deseas descartar a est@ candidat@?',
            TEXTAREA_PLACEHOLDER: 'Escribe aquí el motivo. Solo tú y tu equipo podrán verlo; no se notificará el motivo a est@ candidat@.',
            CONFIRM: 'Descartar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Descartar candidat@s',
            MESSAGE: '¿Estás segur@ que deseas descartar a est@s candidat@s?',
            TEXTAREA_PLACEHOLDER: 'Escribe aquí el motivo. Solo tú y tu equipo podrán verlo; no se notificará el motivo a est@s candidat@s.',
            CONFIRM: 'Descartar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Descartad@',
            SUCCESS: { TEXT: 'Candidat@ descartad@ correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al descartar un/a candidat@.' },
          },
        },
        BULK_RESULT: {
          PARTIAL: 'Acción aplicada a {applied} y omitida en {skipped} candidat@s.',
          NOTHING_APPLIED: 'No se aplicó la acción a ningun@ de l@s {skipped} candidat@s.',
        },
        SKIP_REASON: {
          ALREADY_DISCARDED: 'ya descartad@s',
          ALREADY_SELECTED: 'ya finalistas',
          ALREADY_IN_PROCESS: 'ya en proceso',
          ALREADY_IN_REVIEW: 'ya en revisión',
          CANDIDATE_NOT_DISCARDED: 'no descartad@s',
          INTERVIEW_ALREADY_ANSWERED: 'entrevista ya respondida',
          INTERVIEW_NOT_FOUND: 'sin entrevista',
          ACCESS_DENIED: 'acceso denegado',
          ERROR_ACTION: 'error al aplicar la acción',
          GENERIC: 'motivo no especificado',
          CANDIDATE_NOT_SUGGESTED: 'no sugerid@s',
          CHAT_ERROR: 'error de chat',
        },
        ADD_NOTE: {
          CONFIRM: {
            TITLE: 'Añadir nota',
            MESSAGE: 'Se añadirá esta nota a est@ candidat@.',
            TEXTAREA_PLACEHOLDER: 'Escribe aquí la nota. Solo tú y tu equipo podrán verla.',
            CONFIRM: 'Añadir nota',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Añadir nota a candidat@s',
            MESSAGE: 'Se añadirá la misma nota a tod@s l@s candidat@s seleccionad@s.',
            TEXTAREA_PLACEHOLDER: 'Escribe aquí la nota. Solo tú y tu equipo podrán verla.',
            CONFIRM: 'Añadir nota',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Nota',
            SUCCESS: { TEXT: 'Nota añadida correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al añadir la nota.' },
          },
        },
        ROLLBACK_DISCARD: {
          BUTTON: 'Recuperar',
          TOOLTIP: 'Recuperar candidat@ descartad@',
          CONFIRM: {
            TITLE: 'Recuperar descarte',
            MESSAGE: '¿Estás segur@ que deseas recuperar el descarte de est@ candidat@?<br/><br/> Esta acción devolverá a est@ candidat@ al estado anterior a ser descartad@.',
            CONFIRM: 'Recuperar descarte',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Recuperar descartes',
            MESSAGE: '¿Estás segur@ que deseas recuperar el descarte de est@s candidat@s?<br/><br/> Esta acción devolverá a est@s candidat@s al estado anterior a ser descartad@s.',
            CONFIRM: 'Recuperar descartes',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Candidat@ recuperad@',
            SUCCESS: { TEXT: 'Candidat@ recuperad@ correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al recuperar un/a candidat@.' },
          },
        },
        DISCARDED_ACTION_BLOCKED: {
          TITLE: 'Candidat@ descartad@',
          MESSAGE: 'Recupéral@ para seguir su proceso.',
          CONFIRM: 'Recuperar',
          CANCEL: 'Cancelar',
        },
        SEND_MESSAGE: {
          CONFIRM: {
            TITLE: 'Enviar mensaje',
            MESSAGE: '¿Estás segur@ que deseas enviar este mensaje al candidat@ seleccionad@?',
            TEXTAREA_PLACEHOLDER: 'Escribe aquí el mensaje que deseas enviar.',
            CONFIRM: 'Enviar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Enviar mensajes',
            MESSAGE: '¿Estás segur@ que deseas enviar estos mensajes a l@s candidat@s seleccionad@s?',
            TEXTAREA_PLACEHOLDER: 'Escribe aquí los mensajes que deseas enviar',
            CONFIRM: 'Enviar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Mensaje enviado',
            SUCCESS: { TEXT: 'Se ha enviado el mensaje correctamente.' },
            ERROR: { TEXT: 'Ha ocurrido un error al enviar el mensaje.' },
          },
        },
        CREATE_INTERVIEW: {
          CONFIRM: {
            TITLE: 'Crear entrevista',
            MESSAGE: 'Esta oferta aún no tiene entrevista. Crea una y, cuando esté lista, envíala a l@s candidat@s que desees.',
            CONFIRM: 'Crear',
            CANCEL: 'Cancelar',
          },
          TOOLTIP: 'Crear entrevista para esta oferta',
        },
        SEND_OFFER_TO_SUGGESTED: {
          CONFIRM: {
            TITLE: 'Enviar oferta',
            MESSAGE: '¿Estás segur@ que quieres enviar una invitación a esta persona para que se inscriba en la oferta?',
            CONFIRM: 'Enviar invitación',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Enviar oferta a múltiples candidat@s',
            MESSAGE: '¿Estás segur@ que quieres enviar una invitación a estas personas para que se inscriban en la oferta?\n',
            CONFIRM: 'Enviar invitaciones',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Envío de invitaciones',
            SUCCESS: { TEXT: 'Invitaciones enviadas correctamente.' },
            ERROR: { TEXT: 'Error al enviar invitaciones.' },
          },
        },
        DISCARD_SUGGESTED: {
          CONFIRM: {
            TITLE: 'Descartar candidat@ sugerid@',
            MESSAGE: '¿Estás segur@ que quieres descartar a esta persona de l@s candidat@s sugerid@s? Una vez que lo hagas, desaparecerá de esta lista y no podrás recuperarla.',
            CONFIRM: 'Descartar',
            CANCEL: 'Cancelar',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Descartar candidat@s sugerid@s',
            MESSAGE: '¿Estás segur@ que quieres descartar a estas personas de l@s candidat@s sugerid@s? Una vez que lo hagas, desaparecerán de esta lista y no podrás recuperarlas.',
            CONFIRM: 'Descartar',
            CANCEL: 'Cancelar',
          },
          NOTIFICATION: {
            TITLE: 'Candidat@s descartad@s',
            SUCCESS: { TEXT: 'Candidat@s descartad@s correctamente.' },
            ERROR: { TEXT: 'Error al descartar candidat@s.' },
          },
        },
      },
      INTERVIEW: {
        TITLE: 'Entrevista',
        NOT_SEND: {
          TITLE: 'Entrevista no enviada',
          TEXT: 'Aún no le has enviado la entrevista a est@ candidat@. Haz clic en <b>Enviar entrevista</b> para enviársela.',
        },
        QUESTION: {
          NO_ANSWER: {
            TITLE: 'Sin respuesta',
            TEXT: 'El candidat@ no ha respondido esta pregunta de la entrevista.',
          },
        },
        SEND_WITHOUT_ANSWER: {
          TITLE: 'Sin respuesta',
          TEXT: 'La entrevista ya fue enviada a est@ candidat@, pero aún no la ha respondido. Haz click en <b>Reenviar</b>.',
        },
        NO_INTERVIEW: {
          TITLE: 'Sin entrevista',
          TEXT: 'La oferta no tiene entrevista configurada.',
        },
      },
      TABLE: {
        TITLE: 'Historial de la candidatura',
        HEADER: {
          CREATED_BY: 'Autor',
          MESSAGE: 'Mensaje',
          CREATED_AT: 'Fecha',
          STATUS: 'Acción',
        },
      },
      TAGS: 'Etiquetas',
      REQUIREMENTS: 'Requisitos',
      REQUIREMENTS_MET: '{{ current }} de {{ total }}',
      NEXT: 'Siguiente',
      PREVIOUS: 'Anterior',
      CONFIRM_DISCARD: {
        HEADER: 'Descartar cambios',
        MESSAGE: 'Tienes cambios sin guardar. ¿Estás segur@ de continuar?',
        ACCEPT: 'Continuar',
        REJECT: 'Cancelar',
      },
    },
    SUCCESS: {
      DUPLICATED: 'Oferta duplicada correctamente',
      DUPLICATED_AND_REDIRECTING: 'Oferta duplicada correctamente. Redirigiendo a la oferta',
      PIN_TOGGLED: 'Estado de fijado actualizado correctamente',
    },
  },
} as const;
